import {
  queryOptions,
  useQuery,
  type UseQueryResult,
} from "@tanstack/react-query";

import type { ApiClient } from "@/api/client";
import { useApiClient } from "@/api/client-context";
import { qk } from "@/api/query-keys";

/**
 * 自分の所属グループ。
 *
 * SpiffArena には「グループ一覧」API が無く（`/user-groups/for-current-user` のみ）、
 * かつ所属の正本は Zeus IdP の claim（#24）なので、この画面では自分の所属と
 * 権限の可視化に限る。メンバーの追加・削除は IdP 側で行う。
 */
export function myGroupsQueryOptions(client: ApiClient) {
  const fetchGroups = async (): Promise<readonly string[]> => {
    const response = await client.get<unknown>("/user-groups/for-current-user");
    if (!Array.isArray(response)) return [];

    return response.filter((item): item is string => typeof item === "string");
  };

  return queryOptions({
    queryKey: qk.auth.userGroups(),
    queryFn: fetchGroups,
    staleTime: 5 * 60_000,
  });
}

export function useMyGroups(): UseQueryResult<readonly string[]> {
  return useQuery(myGroupsQueryOptions(useApiClient()));
}
